import { LoadingPage }                    from '@/pages/loading';
import { Suspense, type ReactNode }       from 'react';
import { Provider }                       from 'react-redux';
import { store }                          from '../store/store';
import { QueryProvider }                  from '@/shared/providers/query';
import { AuthLoader }                     from './authLoader';
import { OnlineStatusProvider }           from './onlineStatusProvider';
import { injectQueryClient, injectStore } from '@/shared/utils/axios/api';
import { queryClient }                    from '@/shared/utils/reactQuery';

injectStore(store);
injectQueryClient(queryClient);

type AppProviderProps = {
  children: ReactNode
}

const AppProvider = ({ children }: AppProviderProps) => {
  return (
    <Suspense fallback={<LoadingPage />}>
      {import.meta.env.DEV}
      <Provider store={store}>
        <QueryProvider>
          <AuthLoader>
            <OnlineStatusProvider>{children}</OnlineStatusProvider>
          </AuthLoader>
        </QueryProvider>
      </Provider>
    </Suspense>
  )
}

export { AppProvider };
